import { render } from "./BankWireTransfer.vue?vue&type=template&id=28343d18&scoped=true"
import script from "./BankWireTransfer.vue?vue&type=script&lang=js"
export * from "./BankWireTransfer.vue?vue&type=script&lang=js"

import "./BankWireTransfer.vue?vue&type=style&index=0&id=28343d18&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28343d18"]])

export default __exports__